import React, { useEffect, useState } from "react";
import { Button, Form, Input } from "antd";
import FullMask from "layout/FullMask";
import API from "API";
import MessagePage from "components/MessagePage";

const onFinishFailed = (error) => {
    console.log(error);
};

export default function ConfirmPassword({
    token,
    postForgetPassword,
    loading,
}) {
    const [verify, setVerify] = useState(0);
    const [errorMessage, setErrorMessage] = useState("");
    useEffect(()=>{
        API.post("forget-password/", {token: token})
        .then(res=>{
            setVerify(2);
        })
        .catch((error) => {
            if (error.response?.status === 400) {
                if (error.response?.data?.error === "Token has expired") {
                    setVerify(1);
                    setErrorMessage("Đường dẫn đã hết hạn");
                }
                if (error.response?.data?.error === "Token is invalid") {
                    setVerify(1);
                    setErrorMessage("Đường dẫn không hợp lệ");
                }
            }
        })
    },[token])
    return verify === 0 ? <FullMask /> :
    verify === 1 ? <div>
        <MessagePage
            status="403"
            title={errorMessage}
        />
    </div>
    : (
        <>
            <div
                className="d-flex align-items-center"
                style={{ minHeight: "calc(100vh - 64px)" }}
            >
                <div
                    className="bg-white p-4 mx-auto shadow-lg align-center"
                    style={{
                        maxWidth: "420px",
                        borderRadius: "8px",
                        flexGrow: "1",
                    }}
                >
                    <div className="row row-cols-1 justify-content-between mx-0 align-items-center">
                        <h4 className="mx-0 px-0 col-sm-9">
                            Đặt lại mật khẩu
                        </h4>
                        <div
                            style={{ width: "60px" }}
                            className="d-flex justify-content-center"
                        >
                            <img
                                alt="logo"
                                src={process.env.PUBLIC_URL + "/img/logo.png"}
                                width="60px"
                            />
                        </div>
                    </div>
                    <div className="mt-3">
                        Đặt lại mật khẩu của hệ thống học tập
                    </div>
                    <Form
                        name="forget-password"
                        className="mt-3"
                        layout="vertical"
                        labelCol={{
                            span: 24,
                        }}
                        wrapperCol={{
                            span: 24,
                        }}
                        style={{
                            maxWidth: 600,
                            margin: "auto",
                        }}
                        initialValues={{
                            remember: true,
                        }}
                        onFinish={(values) => {
                            if (loading) return;
                            const newData = {
                                password: values.password,
                                token: token,
                            };
                            postForgetPassword(
                                newData,
                                "Thay đổi mật khẩu thành công, hãy đăng nhập"
                            );
                        }}
                        onFinishFailed={onFinishFailed}
                        autoComplete="off"
                    >
                        <Form.Item
                            label="Mật khẩu mới"
                            name="password"
                            rules={[
                                {
                                    required: true,
                                    message: "Nhập mật khẩu mới!",
                                },
                                {
                                    validator: async (_, value) => {
                                        const regex =
                                            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
                                        if (!value) {
                                            return Promise.reject(
                                                "Nhập mật khẩu mới!"
                                            );
                                        }
                                        if (!regex.test(value)) {
                                            return Promise.reject(
                                                "Mật khẩu phải có ít nhất 1 chữ hoa, 1 chữ thường, 1 số, 1 ký tự đặc biệt và ít nhất 8 ký tự!"
                                            );
                                        }
                                        return Promise.resolve();
                                    },
                                },
                            ]}
                        >
                            <Input.Password />
                        </Form.Item>

                        <Form.Item
                            label="Xác thực mật khẩu mới"
                            name="confirm-new-password"
                            dependencies={["password"]}
                            rules={[
                                {
                                    required: true,
                                    message: "Nhập lại mật khẩu mới!",
                                },
                                {
                                    type: "password",
                                    message:
                                        "Nhập xác thực mật khẩu không đúng định dạng!",
                                },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (
                                            !value ||
                                            getFieldValue("password") ===
                                            value
                                        ) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(
                                            new Error(
                                                "Mật khẩu mới bạn nhập không khớp!"
                                            )
                                        );
                                    },
                                }),
                            ]}
                        >
                            <Input.Password />
                        </Form.Item>

                        <Form.Item label={null} className="mb-0">
                            <Button
                                className="w-100 px-0 mx-0"
                                type="primary"
                                htmlType="submit"
                                loading={loading}
                            >
                                Xác nhận
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
        </>
    );
}
